(ns frontend.ui.component.lp-portal.report.overview.big-figures.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.component.grid.style :as grid-style]
   [frontend.ui.style.theme.core :refer [color]]))

(def ^:private count->cols
  {3 4
   4 3})

(defn figure-column
  "`val-count`: the number of values to display. Currently only supports 3 or 4 values (default: 4)"
  ([]
   (figure-column 4))
  ([val-count]
   (with-meta
     {:margin-bottom      "16px"
      :border-right       "1px solid"
      :border-right-color (theme/color [:general-border :border])}
     {:extend [grid-style/column {:small 6 :large (count->cols val-count)}]
      :pseudo
      {:last-child {:border-right :none}}})))
